__turbopack_context__.v({
  "actionButton": "ConsentBanner-module__6dBOAG__actionButton",
  "actions": "ConsentBanner-module__6dBOAG__actions",
  "container": "ConsentBanner-module__6dBOAG__container",
  "header": "ConsentBanner-module__6dBOAG__header",
  "icon": "ConsentBanner-module__6dBOAG__icon",
  "link": "ConsentBanner-module__6dBOAG__link",
  "settingsLink": "ConsentBanner-module__6dBOAG__settingsLink",
  "text": "ConsentBanner-module__6dBOAG__text",
  "title": "ConsentBanner-module__6dBOAG__title",
});
